import React, { FC } from 'react';
import { VolunteerModel } from '../../../../shared/volunteer';
import { MessageCard, PageHeader, UserStateComponent } from '../../../components';
import { useTranslation } from '../../../translations';
import { Fetcher, isResourceError, useConvention, useFetcher, useUserSafe } from '../../../utils';
import { VolunteerFormComponent, VolunteerLoadError } from './VolunteerForm';

export const VolunteerComponent: FC = () => {
  const user = useUserSafe();
  const { ts } = useTranslation();
  const { enableVolunteers } = useConvention();

  const fetcher = useFetcher(async () => {
    let volunteer: VolunteerModel | undefined;

    try {
      volunteer = await api.getUserVolunteer(user.id);
    } catch (error) {
      if (!isResourceError(error)) {
        throw error;
      }
    }

    const form = await api.getVolunteerForm();

    return {
      form,
      volunteer,
    };
  });

  if (!enableVolunteers) {
    return (
      <UserStateComponent>
        <PageHeader>{ts('volunteer.form.volunteer_application')}</PageHeader>
        <MessageCard icon="remove_circle" id="volunteerClosed" level="danger">
          {ts('volunteer.form.volunteer_applications_for_the_convention')}
        </MessageCard>
      </UserStateComponent>
    );
  }

  if (fetcher.error) {
    return <VolunteerLoadError error={fetcher.error} />;
  }

  if (!fetcher.data) {
    return <Fetcher result={fetcher} />;
  }

  return (
    <UserStateComponent>
      <PageHeader>{ts('volunteer.form.volunteer_application')}</PageHeader>
      <VolunteerFormComponent
        callback={fetcher.refresh}
        form={fetcher.data.form}
        initialVolunteer={fetcher.data.volunteer}
        user={user}
      />
    </UserStateComponent>
  );
};
